import { BlinkoLetter, BlinkoMode } from './constants';

// Event system for physics engine
export type GameEventType = 
  | 'ball-hit-bin'
  | 'special-pin-hit'
  | 'letter-activated'
  | 'mode-changed'
  | 'ball-removed'
  | 'game-end'
  | 'play-sound';

export type BallHitBinPayload = null | {
  bin: number;
};

export type SpecialPinHitPayload = {
  expGained: boolean;
};

export type LetterActivatedPayload = {
  letter: BlinkoLetter;
  binIndex: number;
};

export type ModeChangedPayload = {
  mode: BlinkoMode;
};

export type PlaySoundPayload = {
  soundType: 'click' | 'score' | 'error' | 'tick' | 'special';
  volume?: number;
};

export type BallHitBinEvent = { type: 'ball-hit-bin'; payload: BallHitBinPayload };
export type SpecialPinHitEvent = { type: 'special-pin-hit'; payload: SpecialPinHitPayload };
export type LetterActivatedEvent = { type: 'letter-activated'; payload: LetterActivatedPayload };
export type ModeChangedEvent = { type: 'mode-changed'; payload: ModeChangedPayload };
export type PlaySoundEvent = { type: 'play-sound'; payload: PlaySoundPayload };
export type BallRemovedEvent = { type: 'ball-removed'; payload: Record<string, never> };
export type GameEndEvent = { type: 'game-end'; payload: Record<string, never> };

export type GameEventPayload = 
  | BallHitBinEvent
  | SpecialPinHitEvent
  | LetterActivatedEvent
  | ModeChangedEvent
  | PlaySoundEvent
  | BallRemovedEvent
  | GameEndEvent;

export type GameEvent = GameEventPayload;

export class GameEventEmitter {
  private listeners: Map<GameEventType, Array<(event: GameEvent) => void>> = new Map();

  on(eventType: GameEventType, callback: (event: GameEvent) => void) {
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, []);
    }
    this.listeners.get(eventType)!.push(callback);
  }

  off(eventType: GameEventType, callback: (event: GameEvent) => void) {
    const callbacks = this.listeners.get(eventType);
    if (callbacks) {
      const index = callbacks.indexOf(callback);
      if (index !== -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  emit(event: GameEvent) {
    const callbacks = this.listeners.get(event.type);
    if (callbacks) {
      callbacks.forEach(callback => callback(event));
    }
  }
}
